import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isObject, isSet } from "../../utils/commonUtils";
import FormInputs from "../../components/UI/FormInputs";
import PatientFormService from "../../services/PatientFormService";
import ValidationForm from "./ValidationForm";
import WithRoutify from "../../hoc/WithRoutify";
import { applyPatientSessionAuthFromApiResponse } from "../../utils/patientSessionAuth";
import { OK } from "../../utils/constant";

const PatientFormLogin = (props) => {
    const {Loader}=props;
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({});
    const [validation, setValidation] = useState({});
    const query = new URLSearchParams(useLocation().search);
    const [step,setStep]=useState(1);
    const isPhoneValidation=query.get('phone')=='true'?true:false
    const patient_form_id=query.get('patient_form_id');
    const [isValidForm,setValidForm]=useState(true);
    const navigate = useNavigate();
    useEffect(()=>{
      ValidateEmailLink();
    },[]);
    const  ValidateEmailLink=async()=>{
      Loader(true);
      const response=await PatientFormService.validatePatientForm(patient_form_id);
      setValidForm(response.is_valid);
      Loader(false);
    }

    const changeHandler = (fieldName, value) => {
        setValidation({ ...validation, [fieldName]: '' })
        setFormData({ ...formData, [fieldName]: value });
    }
    const submitHandler=async()=>{
        const payload={
            isPhoneValidation:isPhoneValidation,
            step:step,
            patient_form_id:query.get('patient_form_id'),
            phone:formData.phone||'',
            email:formData.email||'',
            code :formData.code,
        }
        let updateValidation={...validation};
        Loader(true);
        const data=await PatientFormService.patientFormLogin(payload);
        Loader(false);
        if (data.status && data.status === "ERROR") {
            if (isObject(data.data)) {
              for (let key in data.data) {
                updateValidation = {
                  ...updateValidation,
                  [key]: data.data[key].join(","),
                };
              }
            } else {
              props.Toast.error(data.data);
            }
            if (Object.keys(updateValidation).length > 0) {
              setValidation(updateValidation);
            }
          }
          else if (step==2) {
            if (data?.code !== OK) {
              props.Toast.error(typeof data?.data === "string" ? data.data : "Verification failed.");
              return;
            }
            const applied = await applyPatientSessionAuthFromApiResponse(data, dispatch);
            if (!applied) {
              props.Toast.error("Verification succeeded but session could not be started. Try again or contact support.");
              return;
            }
            navigate(`/patient_form?patient_form_id=${patient_form_id}`);
          }
          else{
            setStep(step+1);
          }
    }
    if (isValidForm == false) {
      return <ValidationForm setValidForm={setValidForm} />;
    }

    return (
      <div className="sh_login">
        <div className="sh_login-bleed">
          <main className="sh_login-bg">
            <div className="container sh_login-container">
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="sh_login-hero text-center">
                    <div className="sh_login-brand">SnapEHR</div>
                    <div className="sh_login-title">A New Generation Has Arrived</div>
                    <div className="sh_login-subtitle">
                      Healthcare technology finally built for the way modern medicine works.
                    </div>
                  </div>

                  <div className="d-flex justify-content-center">
                    <div className="sh_login-card">
                      <div className="sh_login-card-inner">
                        <div className="sh_login-card-title">Verification</div>
                        <div className="sh_login-card-subtitle">
                          Confirm your identity to continue your patient form
                        </div>

                        <form
                          className="mt-3"
                          onSubmit={(e) => {
                            e.preventDefault();
                            submitHandler();
                          }}
                        >
                          {step === 1 ? (
                            <>
                              <FormInputs
                                type={isPhoneValidation ? "Phone" : ""}
                                className="form-control form-control-fields sh_login-control"
                                placeholder={isPhoneValidation ? "Enter Phone Number" : "Enter Email Address"}
                                name={isPhoneValidation ? "phone" : "email"}
                                changeHandler={(value) => {
                                  changeHandler(isPhoneValidation ? "phone" : "email", value);
                                }}
                                value={formData[isPhoneValidation ? "phone" : "email"]}
                              />
                              {isSet(validation[query.get("patient") == "true" ? "phone" : "email"]) !== "" ? (
                                <span className="text-danger m-1">
                                  {isSet(validation[isPhoneValidation ? "phone" : "email"], "")}
                                </span>
                              ) : (
                                ""
                              )}
                              <div className="d-flex align-items-start mt-3 mb-2 text-muted">
                                <i className="fas fa-info-circle pt-2 fa-lg"></i>
                                <p className="font-weight-normal text-sm pl-2 mb-0">
                                  {`Please enter your ${isPhoneValidation ? "phone number" : "email address"} to receive a verification code. This code will be used to verify your identity and secure your account.`}
                                </p>
                              </div>
                            </>
                          ) : (
                            <>
                              <FormInputs
                                type=""
                                className="form-control form-control-fields sh_login-control"
                                placeholder="Enter Code"
                                name="code"
                                changeHandler={(value) => {
                                  changeHandler("code", value);
                                }}
                                value={formData.code}
                              />
                              {isSet(validation.code, "") !== "" ? (
                                <span className="text-danger m-1">{isSet(validation.code, "")}</span>
                              ) : (
                                ""
                              )}
                              <div className="d-flex align-items-start mt-3 text-secondary">
                                <i className="fas fa-info-circle pt-2 fa-lg"></i>
                                <p className="font-weight-normal text-sm pl-2 mb-0">
                                  {`Please check your ${isPhoneValidation ? "phone number" : "email address"} for the Verification Code and enter it above.`}
                                </p>
                              </div>
                            </>
                          )}

                          <button type="submit" className="btn sh_login-btn w-100 mt-2">
                            Submit
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
};

export default WithRoutify(PatientFormLogin);
